export function getDomain(url) {
  const urlMainParts = url.split("?");
  return urlMainParts[0].split("/persis/")[0];
}

export function getUrlMainParts(url) {
  const urlMainParts = url.split("?");
  let urlParamParts = urlMainParts[1].split("&");

  urlParamParts = urlParamParts.filter(url => !url.startsWith("_forceNav"));

  const fn = urlParamParts.filter(
    url => url.startsWith("fn") || url.startsWith("function")
  );
  if (fn && fn.length) {
    const funktion = fn[0].split("=")[1];
    let resultUrl = `/main/${funktion}`;
    const action = urlParamParts.filter(url => url.startsWith("action"));
    if (action && action.length) {
      const actionParam = action[0].split("=")[1];
      resultUrl += `/${actionParam}`;
    }

    if (urlParamParts && urlParamParts[1]) {
      const paramsWithoutFunctionAction = urlParamParts.filter(
        url =>
          !url.startsWith("fn") &&
          !url.startsWith("function") &&
          !url.startsWith("action")
      );
      if (paramsWithoutFunctionAction && paramsWithoutFunctionAction.length) {
        resultUrl += `?${paramsWithoutFunctionAction.join("&")}`;
      }
    }
    return resultUrl;
  }

  return url;
}

export function getIframeUrl(url) {
  return getDomain(url) + getUrlMainParts(url);
}
